import React, { Component } from 'react';
import style from './style.scss';


export default class Shelf extends Component {

  renderImage() {
    return (
      <div className="imageWrapper" key={this.props.blurb}>
        <img src={this.props.image} className="mock" />
      </div>
    );
  }

  renderText() {
    return (
      <div className="textWrapper" key={this.props.tagline}>
        <h2>{this.props.tagline}</h2>
        <p>{this.props.blurb}</p>
      </div>
    );
  }

  renderOrder() {
    const components = [this.renderImage(), this.renderText()];
    return this.props.flip ? components.reverse() : components;
  }

  render() {
    return (
      <div className="shelfWrapper">
        {this.renderOrder()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shelf/index.js